import { put, call, take, fork } from 'redux-saga/effects'
import { LLMGetChatMessagesService } from '../../api/llm'
import { llmGetChatMessagesSuccess } from '../../reducers/llm/action'
import { GET_CHAT_MESSAGES } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getChatMessagesFlow(payload) {
  try {
    const { chatId, callback } = payload

    const response = yield call(LLMGetChatMessagesService, chatId)

    yield put(llmGetChatMessagesSuccess(response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getChatMessagesWatcher() {
  while (true) {
    const action = yield take(GET_CHAT_MESSAGES)
    const { payload } = action

    yield fork(generalSaga, getChatMessagesFlow, payload, false)
  }
}
